var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
        'totop',
        {'totop--show': _vm.show}
    ]},[_c('div',{staticClass:"totop__body"},[_c('div',{staticClass:"totop__start"}),_vm._v(" "),_c('div',{staticClass:"totop__container container"}),_vm._v(" "),_c('div',{staticClass:"totop__end"},[_c('button',{staticClass:"totop__button",attrs:{"type":"button"},on:{"click":_vm.onClick}},[_c('ArrowRoundedUp13x8Svg')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }